import { Component, ChangeDetectionStrategy, inject, signal, effect } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ConsentService } from '../../../core/services/consent.service';

@Component({
  selector: 'app-consent-banner',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './consent-banner.component.html',
  styleUrl: './consent-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentBannerComponent {
  readonly consent = inject(ConsentService);
  readonly showPreferences = signal(false);
  readonly analyticsToggle = signal(false);

  constructor() {
    // Sync toggle with current consent state when manage panel opens
    effect(() => {
      if (this.consent.showManagePanel()) {
        this.analyticsToggle.set(this.consent.analyticsConsented());
      }
    });
  }

  acceptAll(): void {
    this.consent.acceptAll();
  }

  rejectAll(): void {
    this.consent.rejectAll();
  }

  togglePreferences(): void {
    this.showPreferences.update(v => !v);
  }

  savePreferences(): void {
    this.consent.savePreferences(this.analyticsToggle());
  }

  saveAndClose(): void {
    this.consent.savePreferences(this.analyticsToggle());
    this.consent.closeManagePanel();
  }

  closeManage(): void {
    this.consent.closeManagePanel();
  }
}
